import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const bloodTestsServices = [
  {
    serviceId: 'BLOOD_001',
    serviceName: 'HbA1c (Glycated Hemoglobin)',
    category: 'Blood Tests',
    specialty: null,
    subCategory: 'Diabetes Monitoring',
    description: 'Blood test to measure average blood sugar levels over 2-3 months',
    cost: 180,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'LAB_HBA1C',
    billableItems: [
      {
        itemId: 'CONS_001',
        itemName: 'Blood collection tube',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['diabetes', 'hba1c', 'monitoring'],
    displayOrder: 1
  },
  {
    serviceId: 'BLOOD_002',
    serviceName: 'Full Blood Count (FBC)',
    category: 'Blood Tests',
    specialty: null,
    subCategory: 'General Pathology',
    description: 'Complete blood analysis including red cells, white cells, and platelets',
    cost: 150,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'LAB_FBC',
    billableItems: [
      {
        itemId: 'CONS_002',
        itemName: 'EDTA blood tube',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['blood', 'fbc', 'complete'],
    displayOrder: 2
  },
  {
    serviceId: 'BLOOD_003',
    serviceName: 'Cholesterol Panel',
    category: 'Blood Tests',
    specialty: null,
    subCategory: 'Cardiovascular Health',
    description: 'Comprehensive cholesterol assessment including HDL, LDL, and triglycerides',
    cost: 220,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'LAB_CHOL',
    billableItems: [
      {
        itemId: 'CONS_003',
        itemName: 'Serum tube',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['cholesterol', 'cardiovascular', 'lipids'],
    displayOrder: 3
  },
  {
    serviceId: 'BLOOD_004',
    serviceName: 'Lipogram',
    category: 'Blood Tests',
    specialty: null,
    subCategory: 'Cardiovascular Health',
    description: 'Detailed lipid profile including all cholesterol fractions',
    cost: 280,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'LAB_LIPO',
    billableItems: [
      {
        itemId: 'CONS_004',
        itemName: 'Serum tube',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['lipogram', 'lipids', 'cardiovascular'],
    displayOrder: 4
  },
  {
    serviceId: 'BLOOD_005',
    serviceName: 'C-Reactive Protein (CRP)',
    category: 'Blood Tests',
    specialty: null,
    subCategory: 'Inflammatory Markers',
    description: 'Blood test to detect inflammation in the body',
    cost: 120,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'LAB_CRP',
    billableItems: [
      {
        itemId: 'CONS_005',
        itemName: 'Serum tube',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['crp', 'inflammation', 'marker'],
    displayOrder: 5
  },
  {
    serviceId: 'BLOOD_006',
    serviceName: 'Thyroid Function Test',
    category: 'Blood Tests',
    specialty: 'Endocrinology',
    subCategory: 'Hormonal Tests',
    description: 'Comprehensive thyroid function assessment including TSH, T3, T4',
    cost: 350,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'LAB_THYROID',
    billableItems: [
      {
        itemId: 'CONS_006',
        itemName: 'Serum tube',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['thyroid', 'hormones', 'endocrine'],
    displayOrder: 6
  }
]

export default bloodTestsServices
